import HttpRequestService from '../../../CommonComponents/HttpRequestService/HttpRequestService';
import { SimpleFilterRequest } from '../Components/Filters';

export type ReconcileEntity = 'contact' | 'organisation';
export type ReconcileOperation = 'link' | 'update';
export type ReconcileMode = 'selected' | 'all_matching';

export interface ReconcileRequest {
    entity: ReconcileEntity;
    operation: ReconcileOperation;
    mode: ReconcileMode;
    ids?: number[];
    filter?: SimpleFilterRequest;
}

export default class ReconcileRepository {
    private _http: HttpRequestService;
    private _url: string;

    constructor() {
        this._http = new HttpRequestService('');
        this._url = '/api/v1/reconcile';
    }

    private isSuccessCode(statusCode: number) {
        return statusCode >= 200 && statusCode <= 299;
    }

    private isClientErrorCode(statusCode: number) {
        return statusCode >= 400 && statusCode <= 499;
    }

    public async reconcile(request: ReconcileRequest): Promise<any> {
        return this._http.post(this._url, request).then((res) => {
            if (this.isSuccessCode(res.status)) return res.data?.data ?? res.data;
            if (this.isClientErrorCode(res.status)) {
                throw new Error(res.data?.error || 'An unknown error occurred');
            }
            throw new Error(res.statusText);
        });
    }
}
